import React, { ReactNode } from "react";
import { Colors } from "../../Constants/colors";
import addButton from "./../../images/add-button.svg";
export const enum CardSize {
  sm,
  md,
  lg,
}
interface CardProps {
  wrapperStyle?: any;
  children: ReactNode;
  cardSize?: CardSize;
  cardTitle?: string;
  cardSubTitle?: string;
  titleStyle?: any;
  canAddOrRemoveCard?: boolean;
  onAddCard?: () => unknown;
  onRemoveCard?: () => unknown;
  totalCard?: number;
  showCard?: boolean;
}

export const Card = ({
  wrapperStyle = {},
  children,
  cardSize,
  cardTitle,
  cardSubTitle,
  titleStyle = {},
  onAddCard = undefined,
  onRemoveCard = undefined,
  totalCard = 1,
  showCard = true,
}: CardProps) => {
  return (
    <>
      <div
        style={{
          backgroundColor: showCard ? Colors.White : null,
          borderRadius: "5px",
          padding: "28px",
          position: "relative",
          height: "100%",
          ...wrapperStyle,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            display: "flex",
            gap: 10,
          }}
        >
          {onAddCard ? (
            <div
              style={{
                cursor: "pointer",
              }}
              onClick={onAddCard}
            >
              <img
                src={addButton}
                alt="add-icon"
                style={{ height: "16px", width: "16px" }}
              />
            </div>
          ) : (
            <></>
          )}
          {onRemoveCard ? (
            <div
              style={{
                cursor: "pointer",
                transform: "rotate(45deg)",
                fill: "black",
              }}
              onClick={onRemoveCard}
            >
              <img
                src={addButton}
                alt="add-icon"
                style={{ height: "16px", width: "16px" }}
              />
            </div>
          ) : (
            <></>
          )}
        </div>

        <div className="mb-6">
          {cardTitle ? (
            <div
              className="Header text-xl font-medium"
              style={{
                ...titleStyle,
                color: Colors.Black,
              }}
            >
              {cardTitle}
            </div>
          ) : (
            <></>
          )}
          {cardSubTitle ? (
            <div
              className="text-sm mt-2 font-extrathin leading-6"
              style={{
                color: Colors.Grey,
              }}
            >
              {cardSubTitle}
            </div>
          ) : (
            <></>
          )}
        </div>

        {children}
      </div>
    </>
  );
};
